var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-wrapper"},[_c('video',{ref:"video",attrs:{"src":`${_vm.videoPath}/${_vm.source}`,"autoplay":_vm.autoplay,"playsinline":""},on:{"timeupdate":_vm.onTimeUpdate,"ended":_vm.onEnded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }